import * as types from './mutations-type'

const mutations = {
  [types.USER_INFO] (state, data) {
    state.userInfo = data
  },
  // 基础配置信息
  [types.BASE_CONFIG] (state, data) {
    state.baseConfigInfo = data
  },
  [types.CHECK_MOBILE] (state, data) {
    state.isMobile = data
  },
  [types.FIXNAV_DH] (state, data) {
    state.divT = data - 48
  },
  [types.SETLOGINUSER] (state, data) {
    state.loginUser = { ...state.loginUser, ...data }
    sensors.login(data.uid)
  },
  [types.LOGOUT] (state) {
    state.loginUser = null
    sensors.logout()
  }
}

export default mutations
